/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_RecipientInputs */

const en_templates_recipient = /** @type {(inputs: Templates_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient`)
};

const he_templates_recipient = /** @type {(inputs: Templates_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נמען`)
};

/**
* | output |
* | --- |
* | "Recipient" |
*
* @param {Templates_RecipientInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_recipient = /** @type {((inputs?: Templates_RecipientInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_RecipientInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_recipient(inputs)
	return he_templates_recipient(inputs)
});